'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Done$() {
}
export { $c_Lpresto_crud$Done$ as $c_Lpresto_crud$Done$ };
$p = $c_Lpresto_crud$Done$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Done$;
/** @constructor */
function $h_Lpresto_crud$Done$() {
}
export { $h_Lpresto_crud$Done$ as $h_Lpresto_crud$Done$ };
$h_Lpresto_crud$Done$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2135970;
});
$p.l = (function() {
  return "Done";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Done";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$Done$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Done$, "presto.crud$Done$", ({
  Vo: 1,
  bw: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$Done$ as $d_Lpresto_crud$Done$ };
var $n_Lpresto_crud$Done$;
function $m_Lpresto_crud$Done$() {
  if ((!$n_Lpresto_crud$Done$)) {
    $n_Lpresto_crud$Done$ = new $c_Lpresto_crud$Done$();
  }
  return $n_Lpresto_crud$Done$;
}
export { $m_Lpresto_crud$Done$ as $m_Lpresto_crud$Done$ };
//# sourceMappingURL=presto.crud$-Done$.js.map
